import { render } from "./SectionSeparator.vue?vue&type=template&id=ce65fb9a"
const script = {}

const cssModules = script.__cssModules = {}
import style0 from "./SectionSeparator.vue?vue&type=style&index=0&id=ce65fb9a&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script